const ThemeColorSetting = {
  red : "#F1654C",
  white : "#FFFFFF",
  cyan : "#00B5B5",
  black : "#4B5562",
  grey : "#D4D4D4",
  wood : "#ECC790",
  transparent : "rgba(62,70,81,0.5)",
  border : "#EEEEEE",
  statusBar : '#136262',
  paragrapgh : '#838383'
}

export default ThemeColorSetting;



/** WEBPACK FOOTER **
 ** ./src/constants/themeColor.js
 **/